module.exports = __webpack_public_path__ + "static/media/ir.f0236e88.svg";